<template>
<div>
  <receipt-print v-if="current_doc_type == 5"/>
  <cert-of-completion-print v-if="current_doc_type == 7"/>
  <act-reconciliation v-if="current_doc_type == 4"/>
</div>
</template>

<script>
import ReceiptPrint from "@/components/ReceiptPrint.vue";
import CertOfCompletionPrint from "@/components/CertOfCompletionPrint.vue";
import ActReconciliation from "@/components/ActReconciliation.vue";

// 1,INVOICE
// 6,PAY_INVOICE
// 7,CERT_OF_COMPLETION


export default {
  name: "DocumentPrint",
  components: {ActReconciliation, CertOfCompletionPrint, ReceiptPrint},
  data() {
    return {
      current_doc_type: null
    }
  },
  methods: {
    set_doc_type: function (current_doc_type) {
      this.current_doc_type = current_doc_type
    },
  }
}
</script>

<style scoped>

</style>